import $http from '../../axios-instance';
/**
 * Método para obtener todas las lenguas.
 *
 * @param {*} param0
 */
export async function getAllLanguages({ commit }) {
    try {
        const response = await $http.get("languages/list");
        commit("setLanguages", response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    }
}